import ToastifyHelper from "./ToastifyHelper";
import i18next from "i18next";

export default class APIHelper {
    static tratarErro (erro) {
        if(!erro.response){
            //Erro de conexao com o servidor
            if(erro.message === 'Network Error')
            ToastifyHelper.error(
                i18next.t('NaoFoiPossivelComunicarServidor')
            );
            }else{
            //Erro de processamento
            if(erro.response.status !== 500){
                //Se for status 422, busca a mensagem de erro do arquivo de internacionalização
                let msg = erro.response.status === 422 ? i18next.t(erro.response.data.message) : erro.response.data.message;
                ToastifyHelper.warning(msg);
            }else{
                ToastifyHelper.error(i18next.t('OcorreuErroInesperado'));
            }
        }
    }
}